import React from "react";
import "../Terms/Terms.css"; // ✅ Reuse the same CSS

const PrivacyPolicy = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        {/* Header */}
        <div className="terms-header">
          <h1>Privacy Policy</h1>
          <p className="terms-sub">
            At <span className="brand">Shawl Haus</span>, your privacy
            is very important to us. Please read our privacy practices below.
          </p>
        </div>

        {/* Cards */}
        <div className="terms-card">
          <h2>🔹 1. Information We Collect</h2>
          <ul>
            <li>
              Personal details you provide such as name, email, phone number, and
              shipping address.
            </li>
            <li>
              Payment information (processed securely through our payment
              provider).
            </li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>🔹 2. How We Use Your Information</h2>
          <ul>
            <li>To process and fulfill your orders.</li>
            <li>To communicate about your order or account.</li>
            <li>To send promotional emails (only if you opt-in).</li>
            <li>To improve our website and services.</li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>🔹 3. Sharing Your Information</h2>
          <ul>
            <li>We do not sell your personal information.</li>
            <li>
              Information may be shared with third-party service providers for
              order processing, shipping, or payments.
            </li>
            <li>We may share information if required by law.</li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>🔹 4. Cookies & Tracking</h2>
          <ul>
            <li>Our website uses cookies to enhance your shopping experience.</li>
            <li>
              You can disable cookies in your browser settings, but some
              features may not function properly.
            </li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>🔹 5. Data Security</h2>
          <ul>
            <li>
              We use industry-standard security measures to protect your personal
              information.
            </li>
            <li>Payments are processed through secure, encrypted gateways.</li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>🔹 6. Your Rights</h2>
          <p>
            You may request access, correction, or deletion of your personal
            information by contacting us at{" "}
            <span className="brand">[support email]</span>.
          </p>
        </div>

        <div className="terms-card">
          <h2>🔹 7. Updates to this Policy</h2>
          <p>
            <span className="brand">Shawl Haus</span> may update this
            Privacy Policy from time to time. Updated versions will be posted on
            this website with the revision date.
          </p>
        </div>

        {/* Footer */}
        <div className="terms-footer">
          <p>
            &copy; {new Date().getFullYear()}{" "}
            <span className="brand">Shawl Haus</span>. All rights
            reserved.
          </p>
          <p className="small">
            This Privacy Policy is subject to change without notice. Please
            review it regularly for updates.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
